import React, { Component, useState, PropTypes } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { red } from '@mui/material/colors'
import { Grid } from '@mui/material'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

import { Modal } from '@mui/material'
import { LocalForm, Control, Field } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, FormGroup, Input, Label, Button } from 'reactstrap'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TextField from '@mui/material/TextField';

import {
    notValidPrice,
    notValidQuantity,
    notValidPoints,
    notValidUrl,
    notValidStartDate,
} from '../../utilities/message'
import Match from '../../utilities/validation'

import dayjs from 'dayjs'

import { styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'
import { useDispatch, useSelector } from 'react-redux'
import {
    itemListing,
    addMerchantItem,
    deleteMerchantItems,
    editMerchantItem,
} from '../../actions/items'

import Loader from '../../components/Loader'
import 'moment-timezone'
import Pagination from '@mui/material/Pagination'
import {
    productDescription,
    productNameField,
    hivePointsField,
    quantityField,
    StartDateField,
    EndDateField,
    productPrice,
    couponNameField,
    couponRedemptionLinkField,
    couponDescriptionField
} from '../../utilities/message'
import { useEffect } from 'react'
import { check } from 'prettier'
import { withStyles } from '@material-ui/core/styles';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props
    return <IconButton {...other} />
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}))

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        width: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        borderRadius: '5px',
        wordWrap: 'break-word', // Ensure text wraps within the tooltip
        whiteSpace: 'normal', // Allow normal white space handling
        overflow: 'hidden', // Prevent content overflow
        padding: theme.spacing(1), // Add padding for better spacing
    },
}));

const CustomSwitch = withStyles((theme) => ({
    switchBase: {
        '&$checked': {
            color: '#442580',
        },
        '&$checked + $track': {
            backgroundColor: '#442580',
        },
    },
    checked: {},
    track: {},
}))(Switch);

const Items = ({ history }) => {
    const user = useSelector((state) => state.user)
    const today = dayjs()
    const yesterday = dayjs().subtract(1, 'day')
    const [openCongrModal, setOpenCongrModal] = useState(false)
    const [endStartDate, setEndStartDate] = useState(dayjs())
    const [openDeleteModal, setDeleteModal] = useState(false)
    const [openModal, setModal] = useState(false)
    const [files, setFile] = useState(null)
    const [opendrag, setOpen] = useState()
    const [imageUrl, setImageUrl] = useState(null)
    const [expanded, setExpanded] = React.useState(null)
    const [anchorEl, setAnchorEl] = React.useState([])
    const [openAnchorIndex, setOpenAnchorIndex] = useState(null)
    const [deleteAllButton, setDeleteButton] = useState(false)
    const [startvalue, setStartDateValue] = useState(null)
    const [endvalue, setEndDateValue] = useState(null)
    const dispatch = useDispatch()
    const items = useSelector((state) => state.items)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [deleteIds, setDeleteIds] = useState([])
    const [filter, setFilter] = useState(0)
    const [search, setSearch] = useState('')
    const loaders = useSelector((state) => state.loader)
    const [edit, setEdit] = useState(false)
    const [editData, setEditData] = useState(null)
    const [error, setError] = useState('')
    const [imgerror, setImgError] = useState(false)
    const Merchant = useSelector((state) => state.merchant)
    const currentMerchant =
        Merchant?.list.filter((item) => item.id === Merchant.selectedMerchantId) || null
    const merchantData = useSelector((state) => state.merchantProfile)
    const merchantId = user && user.data.roles === "merchant" ? user.data.merchantData.id : Merchant.selectedMerchantId
    const updatePagination = (e) => {
        setLimit(e.target.value)
        setPage(1)
        setDeleteButton(false)
        setDeleteIds([])
    }
    const udpateValue = (str) => {
        if (str !== "") {
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
    }
    const singleDelete = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setDeleteModal(!openDeleteModal)
        dispatch(
            deleteMerchantItems({ merchantItemsIds: deleteIds }, (res) => {
                setDeleteModal(!openDeleteModal)
                setDeleteButton(false)

                const params = {
                    page: page,
                    limit: limit,
                    merchant_id: merchantId,
                }
                if (search != '' && search != null) {
                    params.search = search
                }

                dispatch(
                    itemListing(params, (res) => {
                    }),
                )
            }),
        )
    }

    const [tooltipData, setTooltipData] = useState({
        couponCode: '',
        couponDescription: '',
        couponName: '',
        couponRedemptionLink: '',
        couponOnce: null
    })
    const [showTooltip, setShowTooltip] = useState(false)
    const [showCouponFields, setShowCouponFields] = useState(false)
    const [onceToggle, setOnceToggle] = useState(edit ? editData?.coupon_once : 0);
    const [isMerchantBeeline, setIsMerchantBeeline] = useState()
    const [editorContent, setEditorContent] = useState(edit ? editData?.coupon_description : '');
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean']
        ],
        clipboard: {
            matchVisual: false,
        }
    };
    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link'
    ];
    const handleEditorChange = (content) => {
        setEditorContent(content);
    };

    useEffect(() => {
        if (user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin) {
            history.push("/settings")
        }
        if (user && user.data.roles == "merchant" && user.data.last_login_at == 0) {
            history.push("/settings")
        }
    }, [])

    useEffect(() => {
        setEndStartDate(dayjs(startvalue).add(1, 'day'))
    }, [startvalue])

    useEffect(() => {
        if (items?.list[0]?.merchant_role === 'Beeline') {
            setIsMerchantBeeline(true)
        }
        else {
            setIsMerchantBeeline(false)
        }
    })

    useEffect(() => {
        const params = {
            page: page,
            limit: limit,
            merchant_id: merchantId,
        }
        if (filter == 1) {
            params.order_hive = 'DESC'
        }
        if (filter == 2) {
            params.order_hive = 'ASC'
        }
        if (filter == 3) {
            params.order_price = 'DESC'
        }
        if (filter == 4) {
            params.order_price = 'ASC'
        }
        dispatch(
            itemListing(params, (res) => {
            }),
        )
    }, [limit, page, filter])

    var newData = []
    //************Setting up paramters for table  */

    useEffect(() => {
        if (!openCongrModal) {
            setImageUrl(null)
        }
    }, [openCongrModal])

    useEffect(() => {
        if (edit && editData?.coupon_once !== undefined) {
            setOnceToggle(editData.coupon_once);
        }
    }, [edit, editData]);

    // drag state
    const [dragActive, setDragActive] = React.useState(false)
    // ref
    const inputRef = React.useRef(null)

    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true)
        } else if (e.type === 'dragleave') {
            setDragActive(false)
        }
    }

    // triggers when file is dropped
    const handleDrop = function (e) {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.dataTransfer.files[0].size / 1024

            const allowedTypes = ['image/jpeg', 'image/png']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.dataTransfer.files[0]?.type)) {
                setError('Only JPEG, and PNG images are allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                getBase64(e.dataTransfer.files[0])
                    .then((result) => {
                        var file = result.split(',')

                        setFile(file[1])

                    })
                    .catch((err) => {
                    })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.dataTransfer.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }

    const editItems = (data, e, index) => {

        data = Object.fromEntries(Object.entries(data).filter(([k, v]) => v !== null && v !== ''));

        if (data.is_coupon === 0) {
            setShowCouponFields(false)
        }

        const startDate = data.start_date;
        const endDate = data.end_date;
        // Split the date string based on the 'T' character
        const dateParts = startDate.split('T');
        const endParts = endDate.split('T')
        const date = dateParts[0];
        const end = endParts[0];

        // Split the date parts into year, month, and day
        const [year, month, day] = date.split('-');
        const [endYear, endMonth, endDay] = end.split('-');

        // Format the date as 'MM-DD-YYYY'
        const formattedStartDate = `${month}/${day}/${year}`;
        const formattedEndDate = `${endMonth}/${endDay}/${endYear}`;
        setAnchorEl((prevAnchorEl) => ({
            ...prevAnchorEl,
            [index]: null,
        }))
        setOpenAnchorIndex(null)
        e.preventDefault()
        setImgError(false)
        e.stopPropagation()
        setEdit(true)
        setEditData(data)
        setModal(true)
        setImageUrl(null)
        setStartDateValue(dayjs(formattedStartDate))
        setEndDateValue(dayjs(formattedEndDate))
        document.getElementById("dropdown-container1").blur()

        data?.is_coupon && setShowCouponFields(true)
        setEditorContent(data?.coupon_description)
        setDropdownVisible(false);
    }

    const getBase64 = (file) => {
        return new Promise((resolve) => {
            let fileInfo
            let baseURL = ''
            // Make new FileReader
            let reader = new FileReader()

            // Convert the file to base64 text
            reader.readAsDataURL(file)

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result
                resolve(baseURL)
            }
        })
    }

    // triggers when file is selected with click
    const handleChange = function (e) {
        e.preventDefault()
        setImageUrl(null)
        setFile(null)
        if (e.target.files && e.target.files[0]) {
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.target.files[0].size / 1024

            const allowedTypes = ['image/jpeg', 'image/png']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.target.files[0]?.type)) {
                setError('Only JPEG, and PNG images are allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                getBase64(e.target.files[0])
                    .then((result) => {
                        var file = result.split(',')

                        setFile(file[1])

                    })
                    .catch((err) => {
                    })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.target.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }

    // triggers the input when the button is clicked
    const onButtonClick = (e) => {
        e.preventDefault()
        inputRef.current.click()
    }

    const handleSave = (files) => {
        //Saving files to state for further use and closing Modal.
        setFile(files)
        setOpen(false)
    }
    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#625F6D' : '#442580',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#442580',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#442580',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }))

    const handleModal = () => {
        setModal(!openModal)
        setEdit(false)
        setEditData([])
        setFile(null)
        setImgError(false)
        setImageUrl(null)
        setStartDateValue(null)
        setEndDateValue(null)
        setShowCouponFields(false)
    }
    //testVPN
    const handleSubmit = (e) => {
        let formData = { ...e };
        formData.coupon_once = onceToggle;
        formData.coupon_description = editorContent;

        if (formData.coupon_description === "" || formData.coupon_description === undefined) {
            delete formData.coupon_description;
        }
        if (!showCouponFields) {
            delete formData.coupon_code;
        }
        if (edit) {
            updateMerchant(formData);
        } else {
            if (files == null) {
                setImgError(true);
                setError('Product image should not be empty.');
            } else {
                setImgError(false);
                const data = {
                    ...formData,
                    product_image: files,
                    merchant_id: merchantId,
                    start_date: dayjs(startvalue).format('MM-DD-YYYY'),
                    end_date: dayjs(endvalue).format('MM-DD-YYYY'),
                };

                const currentDate = dayjs().format('MM-DD-YYYY');
                if (dayjs(data.start_date).isBefore(currentDate)) {
                    alert('Start date cannot be earlier than the current date.');
                    return;
                }
                if (dayjs(data.end_date).isBefore(data.start_date)) {
                    alert('End date cannot be earlier than the start date.');
                    return;
                }

                dispatch(
                    addMerchantItem(data, (res) => {
                        if (res) {
                            const params = {
                                page: page,
                                limit: limit,
                                merchant_id: merchantId,
                            };
                            if (search !== '' && search !== null) {
                                params.search = search;
                            }
                            setFile(null);
                            // setOpenCongrModal(true);
                            setModal(false);
                            // setTimeout(() => {
                            //   setOpenCongrModal(false);
                            // }, [2000])
                            dispatch(
                                itemListing(params, (res) => { }),
                            );
                        }
                    }),
                );
            }
        }
    };


    const updateMerchant = (e) => {
        var data
        let formData = { ...e };
        formData.coupon_once = onceToggle;
        if (files == null) {
            data = {
                ...formData,
                ...{
                    id: editData?.id,
                    merchant_id: merchantId,
                    start_date: dayjs(startvalue).format('MM-DD-YYYY'),
                    end_date: dayjs(endvalue).format('MM-DD-YYYY'),
                },
            }
        } else {
            data = {
                ...formData,
                ...{
                    product_image: files,
                    id: editData?.id,
                    merchant_id: merchantId,
                    start_date: dayjs(startvalue).format('MM-DD-YYYY'),
                    end_date: dayjs(endvalue).format('MM-DD-YYYY'),
                },
            }
        }

        const thenDate = dayjs(editData.start_date).format('MM-DD-YYYY')
        const currentDate = dayjs().format('MM-DD-YYYY');
        if (!dayjs(data.start_date).isSame(thenDate) && dayjs(data.start_date).isBefore(currentDate)) {
            alert(`Start date must be either ${thenDate} or a date later than today.`);
            return;
        }
        if (dayjs(data.end_date).isBefore(data.start_date)) {
            alert('End date cannot be earlier than the start date.');
            return;
        }

        dispatch(
            editMerchantItem(data, (res) => {
                if (res) {
                    const params = {
                        page: page,
                        limit: limit,
                        merchant_id: merchantId,
                    }
                    if (search != '' && search != null) {
                        params.search = filter
                    }

                    setFile(null)
                    // setOpenCongrModal(true);
                    setModal(false)
                    // setTimeout(() => {
                    //   setOpenCongrModal(false);
                    // }, [2000])
                    dispatch(
                        itemListing(params, (res) => {
                        }),
                    )
                }
            }),
        )
    }
    const handleClose = (index) => () => {
        setAnchorEl((prevAnchorEl) => ({
            ...prevAnchorEl,
            [index]: null,
        }))
        setOpenAnchorIndex(null)
    }
    const handleExpandClick = (index) => {
        if (expanded == index) {
            setExpanded(null)
        } else {
            setExpanded(index)
        }
    }

    const handleClick = (event) => {
        event.preventDefault()
        history.push('/merchants')
    }

    const handleDeleteModal = (itemId) => {
        setDeleteModal(!openDeleteModal)
        handleClose()
        setDeleteIds([itemId])
        // document.getElementById("dropdown-container1").blur();
        setDropdownVisible(false);
    }

    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    const handleAddSubmit = (e) => {
        setOpenCongrModal(true)
        setModal(false)

        setTimeout(() => {
            setOpenCongrModal(false)
        }, [2000])


    }

    const setSearchValue = (data) => {
        setSearch(data)
        setPage(1)
    }

    const setNewPage = (page) => {
        setPage(page)
        setDeleteButton(false)
        setDeleteIds([])
    }

    const handleTooltip = (id) => {
        const item = items.list.find(item => item.id === id);
        setTooltipData({
            couponCode: item?.coupon_code,
            couponDescription: item?.coupon_description,
            couponName: item?.coupon_name,
            couponRedemptionLink: item?.coupon_redemption_link,
            couponOnce: item?.coupon_once
        });
        setShowTooltip(!showTooltip)
    };

    const style = {
        // transform: 'translate(160%, -4%)',
        width: 525,
        float: 'right',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        height: '100%',
    }

    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" href="/" onClick={handleClick}>
            Merchants
        </Link>,
        <Typography key="3" color="text.primary">
            Item List
        </Typography>,
    ]

    const handleOnceToggle = (checked) => {
        checked ? setOnceToggle(1) : setOnceToggle(0)
    };

    return (
        <div className="itemPage">
            <Loader loading={loaders.isFetching} />

            <div className="titlediv">
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={7}>
                        <div style={{ display: 'flex' }}>
                            <div>
                                {user && user.data.roles !== "merchant" &&
                                    <p className="subheadingitems">
                                        <Stack spacing={2}>
                                            <Breadcrumbs
                                                separator={<NavigateNextIcon fontSize="small" />}
                                                aria-label="breadcrumb"
                                            >
                                                {breadcrumbs}
                                            </Breadcrumbs>
                                        </Stack>
                                    </p>
                                }
                                {user && user.data.roles === "merchant" &&
                                    <p className="subheadingitems">
                                        Item List
                                    </p>
                                }
                                {user && user.data.roles !== "merchant" &&

                                    <h4 className="itemsmallheading">
                                        {currentMerchant[0]?.name}
                                        <span className="subheadingitems">
                                            {' '}
                                            <img
                                                src={require('../../assets/images/Location.png')}
                                            />{' '}
                                            {`${currentMerchant[0]?.streetAddress}, ${currentMerchant[0]?.city}, ${currentMerchant[0]?.zip}`}
                                        </span>
                                    </h4>
                                }
                                {user && user.data.roles === "merchant" &&

                                    <h4 className="itemsmallheading">
                                        {merchantData?.list?.name ?? user.data.merchantData.name}
                                        <span className="subheadingitems">
                                            {' '}
                                            <img
                                                src={require('../../assets/images/Location.png')}
                                            />{' '}
                                            {`${merchantData?.list?.streetAddress ?? user.data.merchantData.streetAddress}, ${merchantData?.list?.city ?? user.data.merchantData.city}, ${merchantData?.list?.zip ?? user.data.merchantData.zip}`}
                                        </span>
                                    </h4>
                                }
                            </div>
                        </div>
                    </Grid>

                    <Grid
                        style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                        }}
                        item
                        xs={12}
                        sm={12}
                        md={5}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={6}>
                                <button
                                    onClick={handleModal}
                                    className="btn btn-primary btn-block merchantAddButton"
                                >
                                    Add New Item
                                </button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <select
                                    onChange={(e) => setFilter(e.target.value)}
                                    className="selectoptioninmerchant"
                                    placeholder="Recent Merchants"
                                    type="select"
                                >
                                    <option value={0}>All</option>
                                    <option value={1}>Descending Hive Points</option>
                                    <option value={2}>Ascending Hive Points</option>
                                    <option value={3}>Descending Price </option>
                                    <option value={4}>Ascending Price</option>
                                </select>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <div className="pagignationdiv">
                <div className="itemsPagination">
                    <p>
                        Showing {items.list.length} out of {items.total_users} Items{' '}
                    </p>
                </div>
                <Stack spacing={2}>
                    <Pagination
                        count={Math.ceil(items.total_users / limit)}
                        page={page}
                        onChange={(e, value) => setNewPage(value)}
                        color="primary"
                    />
                </Stack>
                <div className="pagination2">
                    <p>Rows Per Page</p>
                    <select className='pagination-select' onChange={(e) => updatePagination(e)}>
                            <option selected={limit == 10}>10</option>
                            <option selected={limit == 20}>20</option>
                            <option selected={limit == 30}>30</option>
                    </select>
                </div>
            </div>
            <div style={{ paddingTop: '22px' }}>
                <Grid container spacing={2}>
                    {items.list.map((item, index) => {
                        const startDate = item.start_date;
                        const endDate = item.end_date;
                        // Split the date string based on the 'T' character
                        const dateParts = startDate.split('T');
                        const endParts = endDate.split('T')
                        const date = dateParts[0];
                        const end = endParts[0];

                        // Split the date parts into year, month, and day
                        const [year, month, day] = date.split('-');
                        const [endYear, endMonth, endDay] = end.split('-');

                        // Format the date as 'MM-DD-YYYY'
                        const formattedStartDate = `${month}-${day}-${year}`;
                        const formattedEndDate = `${endMonth}-${endDay}-${endYear}`;
                        return (
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                <div
                                    className="dropdd"
                                    style={{
                                        background: 'white',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <div className="menu-nav">
                                        <div className="menu-item"></div>
                                        <div className="dropdown-container" id="dropdown-container1" tabindex="-1">
                                            <div className="three-dots" onClick={() => setDropdownVisible(!isDropdownVisible)} />

                                            {/* </div> */}

                                            <div className="dropdown" style={{ display: isDropdownVisible ? 'block' : 'none' }}>
                                                <div
                                                    style={{ padding: '3px', cursor: 'pointer' }}
                                                    onClick={(e) => editItems(item, e, index)}
                                                >
                                                    {' '}
                                                    <img
                                                        className="editimg"
                                                        src={require('../../assets/images/edit icon.svg').default}
                                                    />{' '}
                                                    Edit
                                                </div>
                                                <div
                                                    style={{ padding: '3px', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        handleDeleteModal(item?.id)
                                                    }}
                                                >
                                                    <img
                                                        className="editimg"
                                                        src={require('../../assets/images/delete icon.svg').default}
                                                    />{' '}
                                                    Delete
                                                </div>
                                            </div>

                                        </div>

                                        {
                                            item?.is_coupon ?
                                                (<HtmlTooltip
                                                    title={
                                                        <React.Fragment>
                                                            <Typography color="inherit" fontSize={14} fontWeight={12}>Coupon details</Typography>
                                                            <br />
                                                            Name: {tooltipData?.couponName}<br />
                                                            Code: {tooltipData?.couponCode}<br />
                                                            Redemption link: <a href={tooltipData?.couponRedemptionLink} target="_blank" rel="noopener noreferrer">{tooltipData?.couponRedemptionLink}</a><br />
                                                            Description: <span dangerouslySetInnerHTML={{ __html: tooltipData?.couponDescription }}></span>
                                                        </React.Fragment>
                                                    }
                                                >
                                                    <div className="tooltip" onMouseEnter={() => { handleTooltip(item.id) }}>
                                                        {/* <CelebrationOutlinedIcon fontSize='medium' /> */}
                                                        <img src={require("../../assets/images/coupon-svgrepo-com.svg").default} alt="Coupon Icon" />
                                                    </div>
                                                </HtmlTooltip>) : ''
                                        }

                                    </div>

                                    <Card sx={{ maxWidth: 345 }}>

                                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                                            {/* <img src={require("../../assets/images/Image 3.png")} /> */}
                                            <img
                                                crossorigin="anonymous"
                                                src={item?.product_image}
                                                style={{ height: 100 }}
                                            />
                                        </Avatar>
                                        <CardContent
                                            style={{ textAlign: 'center', display: 'grid' }}
                                        >
                                            <Typography
                                                gutterBottom
                                                variant="h5"
                                                className="titleItems"
                                                component="div"
                                            >
                                                {item?.title}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item?.hive_points} Hive Points
                                                <Typography
                                                    gutterBottom
                                                    color="text.secondary"
                                                    component="div"
                                                >
                                                    <p style={{ fontWeight: "700" }}>
                                                        {formattedStartDate}{' '}
                                                        -{' '}
                                                        {formattedEndDate}
                                                    </p>
                                                </Typography>
                                                <h5 className="dollarnumber" variant="h5">
                                                    ${item?.price}
                                                </h5>
                                            </Typography>
                                        </CardContent>

                                        <div
                                            class="hrlinesidebar"
                                            src={require('../../assets/images/hr.png')}
                                        ></div>
                                        <CardActions disableSpacing>
                                            <Typography variant="body2" color="text.secondary">
                                                {expanded != index &&
                                                    item &&
                                                    item.description.substring(0, 50)}
                                                {item.description.length > 50 && expanded != index
                                                    ? '...'
                                                    : ''}
                                            </Typography>

                                            <ExpandMore
                                                expand={expanded == index}
                                                onClick={() => handleExpandClick(index)}
                                                aria-expanded={expanded}
                                                aria-label="show more"
                                            >
                                                <ExpandMoreIcon></ExpandMoreIcon>
                                            </ExpandMore>
                                            <IconButton
                                                aria-label="share"
                                                title="Quantity"
                                                style={{
                                                    cursor: 'unset',
                                                    backgroundColor: 'rgb(239 179 15)',
                                                    borderRadius: '7px',
                                                    height: '28px',
                                                    fontSize: '18px',
                                                    color: 'white',
                                                }}
                                            >
                                                {item.remaining_qty}
                                            </IconButton>
                                        </CardActions>
                                        <Collapse
                                            in={expanded == index}
                                            timeout="auto"
                                            unmountOnExit
                                        >
                                            <CardContent>
                                                <Typography variant="body2" color="text.secondary">
                                                    {expanded == index && item.description}
                                                </Typography>
                                            </CardContent>
                                        </Collapse>
                                    </Card>
                                </div>
                            </Grid>
                        )
                    })}
                </Grid>
            </div>

            <Modal
                open={openDeleteModal}
                onClose={(e) => handleDeleteModal(e)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="deletePopup">
                    <div className="iconshadow">
                        <i className=" deleteIconPopup">
                            <button>
                                <img height={20} src={require('../../assets/images/delete icon.svg').default} />
                            </button>
                        </i>
                    </div>
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Are you Sure?
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Are you sure you want delete this? This action cannot be undone.
                        </Typography>

                        <Typography>
                            <div className="buttonGroupDelete">
                                <button
                                    className="btn btn-primary btn-block cancelButton"
                                    onClick={(e) => handleDeleteModal(e)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary btn-block deleteButtonUser"
                                    onClick={(e) => singleDelete(e)}
                                >
                                    <img src={require('../../assets/images/DeleteWhite.png')} />{' '}
                                    Delete
                                </button>
                            </div>
                        </Typography>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={openModal}
                onClose={handleModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="popupModal">
                    <Typography
                        id="modal-modal-title"
                        className="popuptitle"
                        variant="h6"
                        component="h2"
                    >
                        {edit ? 'Update' : 'Add'} Item
                        <img
                            onClick={() => handleModal()}
                            style={{ float: 'right', cursor: 'pointer' }}
                            src={require('../../assets/images/Vector 635.png')}
                        />
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12}>
                                <LocalForm model="user" onSubmit={(values) => handleSubmit(values)}>
                                    <Row>
                                        <FormGroup>
                                            <Label>Product Image</Label>
                                            <div className="imageinputfield">
                                                <div id="form-file-upload" onDragEnter={handleDrag}>
                                                    <input
                                                        ref={inputRef}
                                                        type="file"
                                                        id="input-file-upload"
                                                        onChange={handleChange}
                                                    />
                                                    <label
                                                        id="label-file-upload"
                                                        htmlFor="input-file-upload"
                                                        className={dragActive ? 'drag-active' : ''}
                                                    >
                                                        <div style={{ textAlign: 'center' }}>
                                                            <i
                                                                class="icon  uploadiconnew"
                                                                style={{
                                                                    height: '100%',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <img
                                                                    style={{ marginTop: '20px' }}
                                                                    src={require('../../assets/images/upload.png')}
                                                                />
                                                            </i>
                                                            <p style={{ margin: '0px' }}>
                                                                Drag and drop your file here or click to upload
                                                            </p>
                                                            <button
                                                                className="upload-button"
                                                                onClick={(e) => onButtonClick(e)}
                                                                style={{ color: '#5c5454' }}
                                                            >
                                                                File Format: JPG Or PNG | 5MB file
                                                                size limit
                                                            </button>
                                                        </div>
                                                    </label>
                                                    {dragActive && (
                                                        <div
                                                            id="drag-file-element"
                                                            onDragEnter={handleDrag}
                                                            onDragLeave={handleDrag}
                                                            onDragOver={handleDrag}
                                                            onDrop={handleDrop}
                                                        ></div>
                                                    )}
                                                </div>

                                            </div>

                                            {imageUrl && !edit && (
                                                <div
                                                    style={{ textAlign: 'center', padding: '10px' }}
                                                >
                                                    <img
                                                        crossorigin="anonymous"
                                                        height={70}
                                                        width={70}
                                                        src={imageUrl}
                                                    />
                                                </div>
                                            )}
                                            {edit && !imageUrl && (
                                                <div
                                                    style={{ textAlign: 'center', padding: '10px' }}
                                                >
                                                    <img
                                                        crossorigin="anonymous"
                                                        height={70}
                                                        width={70}
                                                        src={editData?.product_image}
                                                    />
                                                </div>
                                            )}
                                            {edit && imageUrl && (
                                                <div
                                                    style={{ textAlign: 'center', padding: '10px' }}
                                                >
                                                    <img
                                                        crossorigin="anonymous"
                                                        height={70}
                                                        width={70}
                                                        src={imageUrl}
                                                    />
                                                </div>
                                            )}
                                            {imgerror && <p style={{ color: 'red' }}>{error}</p>}
                                        </FormGroup>
                                        <Col className="column" sm="8" md="8">
                                            <FormGroup>
                                                <div style={{ display: 'flex' }}>
                                                    <Control.text
                                                        model="user.title"
                                                        className="form-control nameField  input-field"
                                                        id="user.title"
                                                        placeholder="Product Name"
                                                        defaultValue={edit ? editData?.title : ''}
                                                        // parser={(value) => udpateValue(value)}
                                                        errors={{
                                                            productNameField: (val) => !val,
                                                        }}
                                                    />
                                                </div>
                                                <Errors
                                                    model="user.title"
                                                    errors={{
                                                        productNameField,
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={12} md={4}>
                                                <Col className="column" sm="12" md="6">
                                                    <FormGroup>
                                                        <div style={{ display: 'flex' }}>
                                                            <Control.text
                                                                model="user.hive_points"
                                                                className="form-control stateField input-field"
                                                                id="user.hive_points"
                                                                placeholder="Hive Points"
                                                                defaultValue={
                                                                    edit
                                                                        ? editData?.hive_points
                                                                        : ''
                                                                }
                                                                errors={{
                                                                    hivePointsField: (val) => !val,
                                                                    notValidPoints: (val) =>
                                                                        val &&
                                                                        !Match.validateNumbers(val),
                                                                }}
                                                            />
                                                        </div>
                                                        <Errors
                                                            model="user.hive_points"
                                                            errors={{
                                                                hivePointsField,
                                                                notValidPoints
                                                            }}
                                                            wrap={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={4}>
                                                <Col className="column" sm="12" md="12">
                                                    <FormGroup>
                                                        <div style={{ display: 'flex' }}>
                                                            <Control.text
                                                                model="user.price"
                                                                className="form-control zipField input-field"
                                                                id="user.price"
                                                                defaultValue={
                                                                    edit ? editData?.price : ''
                                                                }
                                                                placeholder="Product Price"
                                                                errors={{
                                                                    productPrice: (val) => !val,
                                                                    notValidPrice: (val) =>
                                                                        val &&
                                                                        !Match.validateFloat(val),
                                                                }}
                                                            />
                                                        </div>
                                                        <Errors
                                                            model="user.price"
                                                            errors={{
                                                                productPrice,
                                                                notValidPrice,
                                                            }}
                                                            wrap={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={4}>
                                                <Col className="column" sm="12" md="6">
                                                    <FormGroup>
                                                        <div style={{ display: 'flex' }}>
                                                            <Control.text
                                                                model="user.qty"
                                                                className="form-control stateField input-field"
                                                                id="user.qty"
                                                                placeholder="Quantity"
                                                                defaultValue={
                                                                    edit ? editData?.remaining_qty : ''
                                                                }
                                                                errors={{
                                                                    quantityField: (val) => !val,
                                                                    notValidQuantity: (val) =>
                                                                        val &&
                                                                        !Match.validateNumbers(val),
                                                                }}
                                                            />
                                                        </div>
                                                        <Errors
                                                            model="user.qty"
                                                            errors={{
                                                                quantityField,
                                                                notValidQuantity
                                                            }}
                                                            wrap={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Grid>
                                        </Grid>
                                        <Col className="column" sm="8" md="8">
                                            <FormGroup>
                                                <div style={{ display: 'flex' }}>
                                                    <Control.textarea
                                                        model="user.description"
                                                        className="form-control  description input-field"
                                                        id="user.description"
                                                        // parser={(value) => udpateValue(value)}
                                                        defaultValue={
                                                            edit ? editData?.description : ''
                                                        }
                                                        rows={6}
                                                        maxLength={400}
                                                        placeholder="Description"
                                                        errors={{
                                                            productDescription: (val) => !val,
                                                        }}
                                                    />
                                                </div>
                                                <Errors
                                                    model="user.description"
                                                    errors={{
                                                        productDescription,
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                        {/* coupon code starts */}
                                        {!isMerchantBeeline &&
                                            <>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={12} md={6}>
                                                        <Col className="column" sm="12" md="12">
                                                            <FormGroup>
                                                                <div style={{ display: 'flex' }}>
                                                                    <Control.text
                                                                        onChange={(e) => { setShowCouponFields(e.target.value.trim().length !== 0); }}
                                                                        model="user.coupon_code"
                                                                        className="form-control zipField input-field"
                                                                        id="user.coupon_code"
                                                                        defaultValue={
                                                                            edit ? editData?.coupon_code : ''
                                                                        }
                                                                        placeholder="Coupon Code (optional)"
                                                                    />
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                    </Grid>
                                                    {showCouponFields &&
                                                        <>
                                                            <Grid item xs={12} sm={12} md={6}>
                                                                <Col className="column" sm="12" md="12">
                                                                    <FormGroup>
                                                                        <div style={{ display: 'flex' }}>
                                                                            <Control.text
                                                                                model="user.coupon_name"
                                                                                className="form-control stateField input-field"
                                                                                id="user.coupon_name"
                                                                                placeholder="Coupon Name"
                                                                                defaultValue={
                                                                                    edit
                                                                                        ? editData?.coupon_name
                                                                                        : ''
                                                                                }
                                                                                errors={{
                                                                                    couponNameField: (val) => !val,
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <Errors
                                                                            model="user.coupon_name"
                                                                            errors={{
                                                                                couponNameField,
                                                                            }}
                                                                            wrap={true}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12}>
                                                                <Col className="column" sm="12" md="12">
                                                                    <FormGroup>
                                                                        <div style={{ display: 'flex' }}>
                                                                            <Control.text
                                                                                model="user.coupon_redemption_link"
                                                                                className="form-control stateField input-field"
                                                                                id="user.coupon_redemption_link"
                                                                                placeholder="Redemption Link"
                                                                                defaultValue={
                                                                                    edit ? editData?.coupon_redemption_link : ''
                                                                                }
                                                                                errors={{
                                                                                    couponRedemptionLinkField: (val) => !val,
                                                                                    notValidUrl: (val) =>
                                                                                        val &&
                                                                                        !Match.validateURL(val),
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <Errors
                                                                            model="user.coupon_redemption_link"
                                                                            errors={{
                                                                                couponRedemptionLinkField,
                                                                                notValidUrl
                                                                            }}
                                                                            wrap={true}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12}>
                                                                <Col className="column" sm="12" md="12">
                                                                    <FormGroup>
                                                                        <div style={{ display: 'flex' }}>
                                                                            <ReactQuill
                                                                                placeholder="Coupon Description"
                                                                                model="user.coupon_description"
                                                                                id="user.coupon_description"
                                                                                defaultValue={
                                                                                    edit ? editData?.coupon_description : ''
                                                                                }
                                                                                onChange={(e) => { handleEditorChange(e) }}
                                                                                modules={modules}
                                                                                formats={formats}
                                                                                theme="snow"
                                                                                style={{ height: '200px' }}
                                                                            // errors={{
                                                                            //     couponDescriptionField: (val) => !val,
                                                                            // }}
                                                                            />
                                                                        </div>
                                                                        {/* <Errors
                                                                            model="user.coupon_description"
                                                                            errors={{
                                                                                couponDescriptionField,
                                                                            }}
                                                                        /> */}
                                                                    </FormGroup>
                                                                </Col>
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12}>
                                                                <Col className="column" sm="12" md="12">
                                                                    <FormGroup>
                                                                        <div style={{ display: 'flex', marginTop: '70px' }}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <CustomSwitch
                                                                                        checked={onceToggle}
                                                                                        onChange={(e) => handleOnceToggle(e.target.checked)}
                                                                                        color='primary'
                                                                                        defaultValue={edit ? editData?.coupon_once : onceToggle}
                                                                                    />
                                                                                }
                                                                                model="user.coupon_once"
                                                                                id='user.coupon_once'
                                                                                label="Allow Only Once"
                                                                            />
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Grid>
                                                        </>
                                                    }
                                                </Grid>
                                            </>
                                        }
                                        {/* coupon code ends */}

                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <Col className="column" sm="8" md="5">
                                                    <FormGroup
                                                        style={{ gap: '10px', display: 'flex' }}
                                                    >

                                                        <div>
                                                            <Label>Start Date</Label>

                                                            <LocalizationProvider
                                                                dateAdapter={AdapterDayjs}
                                                            >
                                                                <DemoContainer
                                                                    components={[
                                                                        'DatePicker',
                                                                        'DatePicker',
                                                                    ]}
                                                                >
                                                                    <DatePicker
                                                                        className="form-control "
                                                                        value={startvalue}
                                                                        defaultValue={yesterday}
                                                                        disablePast
                                                                        onChange={(newVal) =>
                                                                            setStartDateValue(newVal)
                                                                        }
                                                                    />
                                                                </DemoContainer>
                                                            </LocalizationProvider>
                                                            {!startvalue && (
                                                                <div>
                                                                    <Control.text
                                                                        model="user.startDate"
                                                                        className="form-control stateField input-field"
                                                                        id="user.startDate"
                                                                        placeholder="Start Date"
                                                                        validateOn="change"
                                                                        value={startvalue}
                                                                        hidden="true"
                                                                        errors={{
                                                                            StartDateField: (val) =>
                                                                                !val,
                                                                        }}
                                                                    />
                                                                    <Errors
                                                                        model="user.startDate"
                                                                        errors={{
                                                                            StartDateField,
                                                                            notValidStartDate
                                                                        }}
                                                                        wrap={true}
                                                                    />
                                                                </div>
                                                            )}

                                                        </div>

                                                    </FormGroup>
                                                </Col>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <Col className="column" sm="8" md="5">
                                                    <FormGroup
                                                        style={{ gap: '10px', display: 'flex' }}
                                                    >
                                                        <div>
                                                            <Label>End Date</Label>

                                                            <LocalizationProvider
                                                                dateAdapter={AdapterDayjs}
                                                            >
                                                                <DemoContainer
                                                                    components={[
                                                                        'DatePicker',
                                                                        'DatePicker',
                                                                    ]}
                                                                >
                                                                    <DatePicker
                                                                        className="form-control "
                                                                        value={endvalue}
                                                                        defaultValue={endvalue}
                                                                        minDate={endStartDate}
                                                                        disablePast
                                                                        onChange={(val) => setEndDateValue(val)}
                                                                    />
                                                                </DemoContainer>
                                                            </LocalizationProvider>
                                                            {!endvalue && (
                                                                <div>
                                                                    <Control.text
                                                                        model="user.endDate"
                                                                        className="form-control stateField input-field"
                                                                        id="user.endDate"
                                                                        placeholder="End Date"
                                                                        validateOn="change"
                                                                        value={endvalue}
                                                                        hidden="true"
                                                                        errors={{
                                                                            EndDateField: (val) =>
                                                                                !val,
                                                                        }}
                                                                    />
                                                                    <Errors
                                                                        model="user.endDate"
                                                                        errors={{
                                                                            EndDateField,
                                                                        }}
                                                                        wrap={true}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Grid>
                                        </Grid>

                                        {/* <Grid container spacing={1}>
                      
                      </Grid> */}

                                        <Col sm="12 form-button-spacing column">
                                            <div>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-block "
                                                >
                                                    {edit ? 'Update' : 'Add'} Product
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </LocalForm>
                            </Grid>
                        </Grid>
                    </Typography>
                </Box>
            </Modal>
            <Modal
                open={openCongrModal}
                onClose={() => {
                    setOpenCongrModal(false)
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="deletePopup">
                    <div className="iconshadow">
                        <i className="congratulationsForgotEnd">
                            <button>
                                <img src={require('../../assets/images/Group 427319061.png')} />
                            </button>
                        </i>
                    </div>
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Congratulations
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            You have successfully added the product.
                        </Typography>

                        <Typography>
                            <div className="buttonGroupDelete">
                                <button
                                    className="btn btn-primary btn-block okaybutton"
                                    onClick={() => {
                                        setOpenCongrModal(false)
                                    }}
                                >
                                    Okay
                                </button>
                            </div>
                        </Typography>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default Items
